import { render, staticRenderFns } from "./CustomerCreditLimit.vue?vue&type=template&id=408f27f6&scoped=true"
import script from "./CustomerCreditLimit.vue?vue&type=script&lang=js"
export * from "./CustomerCreditLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408f27f6",
  null
  
)

export default component.exports